import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { motion, useReducedMotion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
export function Hero() {
  const {
    t
  } = useLanguage();
  const prefersReducedMotion = useReducedMotion();
  return <section id="home" className="relative min-h-screen w-full overflow-hidden flex items-center justify-center" data-id="element-91">
      <div className="absolute inset-0" data-id="element-92">
        <img src="https://cdn.magicpatterns.com/uploads/6D87V7Nvf1t6ntM6riPJ6D/DSC01412.jpg" alt="Guests enjoying a private Blu Ocean boat tour in Puerto Rico" className="w-full h-full object-cover object-center" data-id="element-93" />
        <div className="absolute inset-0 bg-ocean-dark/65" data-id="element-94" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 pt-24 pb-16 text-center" data-id="element-95">
        <motion.img initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.65,
        ease: 'easeOut'
      }} src="https://cdn.magicpatterns.com/uploads/aifgHKgDB7GaFaemiHaRod/LOGO_PNG_ORIGI.png" alt="Blu Ocean Tours" className="h-28 sm:h-36 md:h-44 w-auto mx-auto mb-7 drop-shadow-[0_8px_24px_rgba(0,180,216,0.35)]" data-id="element-96" />

        <motion.h1 initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.75,
        delay: 0.12,
        ease: 'easeOut'
      }} className="text-5xl md:text-7xl font-heading font-bold text-white mb-6 drop-shadow-xl leading-tight" data-id="element-97">
          {t.hero.headline}
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.25,
        ease: 'easeOut'
      }} className="text-lg md:text-2xl text-sand-light max-w-3xl mx-auto mb-10 font-light leading-relaxed" data-id="element-98">
          {t.hero.subheadline}
        </motion.p>

        <motion.a href="https://wa.link/qca29f" target="_blank" rel="noreferrer" initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0,
        scale: prefersReducedMotion ? 1 : [1, 1.045, 1],
        boxShadow: prefersReducedMotion ? '0 0 20px rgba(0,180,216,0.45)' : ['0 0 18px rgba(0,180,216,0.4)', '0 0 34px rgba(72,202,228,0.85)', '0 0 18px rgba(0,180,216,0.4)']
      }} transition={{
        opacity: {
          duration: 0.65,
          delay: 0.4,
          ease: 'easeOut'
        },
        y: {
          duration: 0.65,
          delay: 0.4,
          ease: 'easeOut'
        },
        scale: {
          duration: 1.8,
          delay: 0.7,
          repeat: Infinity,
          ease: 'easeInOut'
        },
        boxShadow: {
          duration: 1.8,
          delay: 0.7,
          repeat: Infinity,
          ease: 'easeInOut'
        }
      }} whileHover={prefersReducedMotion ? undefined : {
        scale: 1.07
      }} className="inline-flex items-center justify-center gap-2 bg-turquoise hover:bg-turquoise-light text-white px-8 py-4 rounded-full font-semibold text-lg w-full sm:w-auto focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white" data-id="element-99">
          <MessageCircle size={21} data-id="element-100" />
          {t.hero.cta}
        </motion.a>
      </div>
    </section>;
}